import { httpApi } from '@app/api/http.api'

export interface AuthData {
  email: string
  password: string
}

export interface SignUpRequest {
  firstName: string
  lastName: string
  email: string
  password: string
}

export interface ResetPasswordRequest {
  email: string
}

export interface SecurityCodePayload {
  code: string
}

export interface NewPasswordData {
  newPassword: string
}

export interface LoginRequest {
  email: string
  password: string
}

export interface LoginResponse {
  id: string
  token: string
  consentRequired?: boolean
}

export const login = (loginPayload: LoginRequest): Promise<LoginResponse> =>
  httpApi.post<LoginResponse>('auth/signin', { ...loginPayload }).then(({ data }) => data)

// not used yet
export const signUp = (signUpData: SignUpRequest): Promise<undefined> =>
  httpApi.post<undefined>('signUp', { ...signUpData }).then(({ data }) => data)

export const resetPassword = (resetPasswordPayload: ResetPasswordRequest): Promise<undefined> =>
  httpApi.post<undefined>('forgotPassword', { ...resetPasswordPayload }).then(({ data }) => data)

export const verifySecurityCode = (securityCodePayload: SecurityCodePayload): Promise<undefined> =>
  httpApi.post<undefined>('verifySecurityCode', { ...securityCodePayload }).then(({ data }) => data)

export const setNewPassword = (newPasswordData: NewPasswordData): Promise<undefined> =>
  httpApi.post<undefined>('setNewPassword', { ...newPasswordData }).then(({ data }) => data)
